import { create } from 'zustand';

export type TaskStatus =
  | 'NOT_STARTED'
  | 'IN_PROGRESS'
  | 'WAITING'
  | 'DONE'
  | 'CLAIMED';
export type TaskType =
  | 'sponsors'
  | 'quest-daily'
  | 'partners'
  | 'starter-quest'
  | 'advanced-quest'
  | 'expert-quest'
  | 'daily-bonus';
export type TaskProvider =
  | 'PARTNERS'
  | 'DAILY'
  | 'SPONSORS'
  | 'BARZHA'
  | 'TAPPADS'
  | 'DREAMCOIN_CLICK'
  | 'DREAMCOIN_SUBSCRIBE'
  | 'BARZHA_CLICK'
  | 'FLYER';

export interface Task {
  id: string | number;
  title: string;
  image?: string;
  centerIcon?: string;
  icon: string;
  type: string;
  group?: 'individual' | 'combined';
  description?: string;
  rewards?: {
    dc?: number;
    tickets?: number;
    [key: string]: number | undefined;
  };
  status: 'NOT_STARTED' | 'IN_PROGRESS' | 'WAITING' | 'DONE' | 'CLAIMED';
  buttonText: string;
  link?: string;
  is_subscribed?: boolean;
  progress?: {
    current: number;
    total: number;
  };
  provider: TaskProvider;
  responseType?: string;
  completed_elsewhere?: boolean;
  // meta?: {
  //   adId?: number;
  //   ads?: any[];
  // };
  // onClick?: () => Promise<boolean>;
}

export interface TraffyTask {
  id: string;
  image_url: string;
  is_completable: boolean;
  is_test: boolean;
  link: string;
  target: string;
  title: string;
}

export interface BarzhaClickAd {
  id: number;
  title: string;
  description?: string;
  image_url?: string;
  reward_amount?: number;
  reward_type?: string;
  exchange_ad_id?: number;
  image_href?: string;
  status?: string;
  visibility?: boolean;
}

export interface BarzhaClickResponse {
  status: string;
  data: BarzhaClickAd[];
  started_tasks?: BarzhaClickAd[];
  webscoket_channel_name?: string;
  webscoket_client_token?: string;
  error?: string;
}

export interface TaskStatusItem {
  status: string;
  task_id: string;
  type: string;
  visibility: boolean;
}

type ModalStore = {
  open: boolean | 'boost' | 'dailyReward' | string;
  closing: boolean;
  currentTask?: Task | null;
  source?: string;
  setClosing: (arg: boolean) => void;
  setOpen: (
    arg: boolean | 'boost' | 'dailyReward' | string,
    source?: string,
  ) => void;
  setCurrentTask: (task: Task | null) => void;
  handleClose: () => void;
};

export const useModalStore = create<ModalStore>((set) => ({
  open: false,
  closing: false,
  currentTask: null,
  source: undefined,
  setOpen: (arg, source) => set({ open: arg, closing: false, source }),
  setClosing: (arg) => set({ closing: arg }),
  setCurrentTask: (task) => set({ currentTask: task }),
  handleClose: () => {
    set({ closing: true });
    setTimeout(() => {
      set({ closing: false, open: false, source: undefined });
    }, 300);
  },
}));
